import React, { useState } from "react";

import axios from "axios";
import { Jumbotron } from "./migration";
import {
  Container,
  Row,
} from "react-bootstrap";

const ContactMe = ({ heading }) => {
  const [status, setStatus] = useState("Submit");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const { name, email, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    let response = await fetch("http://localhost:5000/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(details),
    });
    setStatus("Submit");
    let result = await response.json();
    alert(result.status);
  };
  return (
    <Jumbotron id="contactMe" className="bg-light m-0">
      <Container className="text-center">

      <h2 className="display-4 mb-5 text-center">
      {heading}
      </h2>

    <form class="Contactform" onSubmit={handleSubmit}>
      <div>
        <input class="feedback-input"  type="text" id="name" placeholder="Name" required />
      </div>
      <div>
        <input class="feedback-input"  type="email" id="email"  placeholder="Email" required />
      </div>
      <div>
        <textarea class="feedback-input"  id="message" placeholder="Message" required />
      </div>
      <button
            className="btn btn-outline-dark btn-lg "
            role="button">
            {status}</button>
    </form>
    </Container>
  </Jumbotron>


  );
};


export default ContactMe;
